module.exports = __webpack_public_path__ + "baf9b673.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/media_ibt@2x.png
// module id = 1191
// module chunks = 0